import * as Yup from "yup";
import { forceInt } from "Utils";

export const AutomationActionValidationSchema = Yup.object().shape({});

export const AutomationActionObjectSchema = {
    id: null,
    uuid: null,
    type: null,
    task_id: null,
    properties: [],
};

export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let action = Object.assign({}, AutomationActionObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        type: requestData.type,
        task_id: requestData.task_id,
        properties: requestData.properties,
    });

    return action;
}
